// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"391":"87a8bdc06f131293","2888":"41259926affd223d"}[chunkId] + ".css";
};